// import React from 'react'
// import { KitSize } from 'components/uiKit/KitTypes'
// import Segmented from 'components/uiKit/Segmented'
// import { OBJECT_FIT_OPTIONS } from 'services/Branding/constants'
// import { useElementStyleCss } from 'services/Branding/hooks'
// import { updateBlock } from 'services/Store/Project/actions'
// import { useProjectDispatch } from 'services/Store/Project/hooks'
// import { setImageObjectFit } from 'services/Store/Project/mutators/element'
import type { ImageEditorActionsType } from './imageTypes'

const ImageEditorActions: ImageEditorActionsType = (/* { block, element, mode } */) => {
  // const dispatch = useProjectDispatch()
  // const styles = useElementStyleCss('image', mode.deviceMode, element.style)
  // const handleChangeScaling = (value: string) => {
  //   const newBlock = setImageObjectFit(element.id, mode.deviceMode, value)(block)
  //   dispatch(updateBlock({ id: block.uuid, value: newBlock }))
  // }

  // return (
  //   <Segmented
  //     name='scaling'
  //     onChange={handleChangeScaling}
  //     options={OBJECT_FIT_OPTIONS}
  //     size={KitSize.XS}
  //     value={styles.image.objectFit}
  //   />
  // )
  return null
}

export default ImageEditorActions
